// Occhio stilizzato per mostrare/nascondere la password: aperto = password nascosta
// (clic per mostrarla), barrato = password visibile (clic per nasconderla).
export default function IconaOcchio({ barrato = false, className = 'w-5 h-5' }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
      <path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z" />
      <circle cx="12" cy="12" r="3" />
      {barrato && <path d="M4 4l16 16" />}
    </svg>
  );
}
